export default {
    getPatients(axios) {
        return axios({
            url: `patients`,
            method: 'GET'
        })
    },
    getTegner(axios) {
        return axios({
            url: `tegner`,
            method: 'GET'
        })
    },
    add(patientData, axios) {
        return axios({
            url: `patients/add`,
            method: 'POST',
            data: patientData
        })
    },
    quickCreate(patientData, axios) {
        return axios({
            url: `patients/quickCreate`,
            method: 'POST',
            data: patientData
        })
    },
    update(id, patientData, axios) {
        return axios({
            url: `patients/${id}/update`,
            method: 'POST',
            data: patientData
        })
    },
    delete(id, axios) {
        return axios({
            url: `patients/${id}/delete`,
            method: 'POST'
        })
    },
    updateContactInfos(id, contactData, axios) {
        return axios({
            url: `patients/${id}/updateContact`,
            method: 'POST',
            data: contactData
        })
    },
    updateAddressInfosFromNotification(addressUrl, addressData, axios) {
        return axios({
            url: addressUrl,
            method: 'POST',
            data: addressData
        })
    },
    updateStudyInfosFromNotification(studyUrl, studyData, axios) {
        return axios({
            url: studyUrl,
            method: 'POST',
            data: studyData
        })
    },

    updateDoctorsInfos(id, doctorsData, axios) {
        return axios({
            url: `patients/${id}/updateDoctors`,
            method: 'POST',
            data: doctorsData
        })
    },

    updateDoctorInfosFromNotification(doctorUrl, doctorData, axios) {
        return axios({
            url: doctorUrl,
            method: 'POST',
            data: doctorData
        })
    },

    updateFirmInfos(id, infoData, axios) {
        return axios({
            url: `patients/${id}/updateSelectFirm`,
            method: 'POST',
            data: infoData
        })
    },
    updateFirmInfosFromNotification(firmUrl, infoData, axios) {
        return axios({
            url: firmUrl,
            method: 'POST',
            data: infoData
        })
    },
    updateJobInfos(id, infoData, axios) {
        return axios({
            url: `patients/${id}/updateJob`,
            method: 'POST',
            data: infoData
        })
    },

    updateJobInfosFromNotification(jobUrl, infoData, axios) {
        return axios({
            url: jobUrl,
            method: 'POST',
            data: infoData
        })
    },
    updateTegnerInfos(id, infoData, axios) {
        return axios({
            url: `patients/${id}/updateTegner`,
            method: 'POST',
            data: infoData
        })
    },
    updateTegnerInfosFromNotification(tegnerUrl, infoData, axios) {
        return axios({
            url: tegnerUrl,
            method: 'POST',
            data: infoData
        })
    },
    get(id, axios) {
        return axios({
            url: `patients/${id}/view`,
            method: 'GET'
        })
    }
}
